import { render, staticRenderFns } from "./ICell.vue?vue&type=template&id=2cc78d3a&scoped=true&"
import script from "./ICell.vue?vue&type=script&lang=js&"
export * from "./ICell.vue?vue&type=script&lang=js&"
import style0 from "./ICell.vue?vue&type=style&index=0&id=2cc78d3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc78d3a",
  null
  
)

export default component.exports